import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useService } from '../ServiceContext';
const ServiceFAQ = () => {
  const [openSection, setOpenSection] = useState(0); // First section open by default
  const { service } = useService();
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  // Check if service or service.Faq is unavailable
  if (!service || !service.Faq || !Array.isArray(service.Faq)) {
    return (
      <div>
        <h3 className="text-orange font-heading font-light text-[14px]">
          FAQs
        </h3>
        <h2 className="font-heading text-[38px] font-medium leading-[1.316em] mb-6 text-thickGreen">
          Everything you need to know about {service?.title || 'this service'}
        </h2>
        <p className="text-gray-500">No FAQs available at this time.</p>
      </div>
    );
  }

  return (
    <div>
      <div>
        <h3 className="text-orange font-heading font-bold text-[14px]">
          FAQs
        </h3>
        <h2 className="font-heading text-[38px] font-medium leading-[1.316em] mb-6 text-thickGreen">
          Everything you need to know about {service.title}
        </h2>
      </div>
      <div className="border-b border-gray-700">
        {service.Faq.map((faq, index) => (
          <div key={index}>
            <h2>
              <button
                type="button"
                className={`flex items-center justify-between w-full py-5 font-medium text-left border-b  border-[#c4d6d6] ${
                  openSection === index
                    ? 'bg-white text-gray-900'
                    : 'text-gray-500'
                }`}
                onClick={() => toggleSection(index)}
              >
                <span className='font-heading text-thickGreen text-[22px] font-medium leading-[1.6em]'>{faq.question}</span>
                {openSection === index ? (
                  <RemoveIcon className="w-3 h-3 shrink-0 text-thickGreen" />
                ) : (
                  <AddIcon className="w-3 h-3 shrink-0 text-thickGreen" />
                )}
              </button>
            </h2>
            <div
              className={`${
                openSection === index ? 'block' : 'hidden'
              } py-5 border-b border-[#c4d6d6]`}
            >
              <p className="mb-2 text-[18px] font-body text-paraGreen font-[500] leading-[1.667em]">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceFAQ;